/**
 * Private modules
 */
const {
  customerId,
  rootId,
  systemGameCategoryIds,
} = require('../.private').components;

module.exports = {
  updateCustomerRunnerTicketSchemeEntriesByRootId: {
    properties: {
      body: {
        properties: {
          systemGameCategoryIds,
        },
        required: ['systemGameCategoryIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          rootId,
        },
        required: [
          'customerId',
          'rootId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
